module.exports = __webpack_public_path__ + "static/media/placeholder-detail.9045c5a8.gif";